<div class="row">
  <div class="col m-auto">
    <div class="align-items-center align-content-center">
      <div class="icon_error">
        <svg viewBox="0 0 8 14" fill="#ba3d21" focusable="false" aria-hidden="true">
          <use xlink:href="#error-small"></use>
        </svg>
      </div>
      <h1 class="h1_error mt-4">Try again later</h1>
    </div>
  </div>
</div>

<div class="row mt-2">
  <div class="col d-flex justify-content-center align-items-center text-center">
    <span class="c11n-text-md c11n-text-md1">
      We are experiencing technical difficulties. We apologize for the temporary inconvenience.
    </span>
  </div>
</div>

<div class="row mt-5">
  <div class="col d-flex justify-content-center align-items-center">
    <c11n-button
      buttonType="button"
      [size]="'medium'"
      variant="primary"
      [labelText]="'Back to confirmations'"
      [fullWidth]="false"
      title="back to confirmations"
      colorMode="on-light"
      [href]="'/'"
    >
    </c11n-button>
  </div>
</div>